import { render, staticRenderFns } from "./BlogPagination.vue?vue&type=template&id=fd90bcd6&scoped=true"
import script from "./BlogPagination.vue?vue&type=script&lang=js"
export * from "./BlogPagination.vue?vue&type=script&lang=js"
import style0 from "./BlogPagination.vue?vue&type=style&index=0&id=fd90bcd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd90bcd6",
  null
  
)

export default component.exports